import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('@/pages/LoginPage.vue'), meta: { public: true } },
    { path: '/callback', name: 'callback', component: () => import('@/pages/CallbackPage.vue'), meta: { public: true } },
    {
      path: '/',
      component: () => import('@/components/layout/AppLayout.vue'),
      children: [
        { path: '', redirect: '/contacts' },
        { path: 'contacts', name: 'contacts', component: () => import('@/pages/contacts/ContactsListPage.vue') },
        { path: 'contacts/new', name: 'contacts-new', component: () => import('@/pages/contacts/ContactFormPage.vue') },
        { path: 'contacts/:id', name: 'contact-detail', component: () => import('@/pages/contacts/ContactDetailPage.vue') },
        { path: 'contacts/:id/edit', name: 'contacts-edit', component: () => import('@/pages/contacts/ContactFormPage.vue') },
        { path: 'districts', name: 'districts', component: () => import('@/pages/districts/DistrictsPage.vue') },
        { path: 'ministries', name: 'ministries', component: () => import('@/pages/ministries/MinistriesPage.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

// ── Navigation guard ──────────────────────────────────────────────────────────
router.beforeEach((to) => {
  if (to.meta.public) return true;

  const auth = useAuthStore();
  if (!auth.isAuthenticated) {
    return { name: 'login' };
  }
  return true;
});
